import { useCallback } from 'react';
import {
  getAnalyticsProvider,
  setAnalyticsProvider,
} from '@livelike/javascript';

export function useAnalytics() {
  const analyticsProvider = getAnalyticsProvider();

  return {
    getAnalyticsProvider,
    setAnalyticsProvider,
    trackEvent: useCallback(
      (event: string, trackObj: unknown) => {
        analyticsProvider?.track?.(event, trackObj);
      },
      [analyticsProvider]
    ),
  };
}
